import React from 'react';

interface Props {
  children?: React.ReactNode;
}

export const HeaderContainer: React.FC<Props> = ({ children }) => {
  return <div className=" mb-4 relative flex justify-center">{children}</div>;
};
